import ochoaMh from "./ochoa-mh";

export default {
  ochoaMh,
};
